import React from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import PersonaBadge from '../../common/PersonaBadge';

interface Props {
  workflow: any;
}

const ConfigConnections: React.FC<Props> = ({ workflow }) => {
  const { darkMode } = useTheme();

  const phases = workflow?.phases || [];
  const connections = workflow?.connections || [];
  const allPersonas = new Map<string, string>();
  phases.forEach((p: any) => {
    (p.config?.personas || []).forEach((pr: any) => {
      allPersonas.set(pr.persona_id, pr.persona_name || pr.persona_id);
    });
  });

  return (
    <div className="space-y-6">
      {/* Phase Graph Summary */}
      <div className={`rounded-xl border p-5 ${darkMode ? 'bg-gray-800/50 border-gray-700' : 'bg-white border-gray-200'}`}>
        <h3 className={`text-sm font-semibold mb-3 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Phase Graph</h3>
        <div className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
          <p>{phases.length} phases, {connections.length} connections</p>
          <div className="mt-2 flex flex-wrap gap-2">
            {phases.map((p: any, i: number) => (
              <span key={p.id} className={`px-2 py-1 text-xs rounded ${darkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-100 text-gray-700'}`}>
                {i + 1}. {p.label || p.id}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* All Personas */}
      <div className={`rounded-xl border p-5 ${darkMode ? 'bg-gray-800/50 border-gray-700' : 'bg-white border-gray-200'}`}>
        <h3 className={`text-sm font-semibold mb-3 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
          Personas ({allPersonas.size})
        </h3>
        <div className="flex flex-wrap gap-3">
          {Array.from(allPersonas.entries()).map(([id, name]) => (
            <PersonaBadge key={id} personaId={id} personaName={name} size="md" />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ConfigConnections;
